import { render, staticRenderFns } from "./yuan.vue?vue&type=template&id=080556aa&scoped=true&"
import script from "./yuan.vue?vue&type=script&lang=js&"
export * from "./yuan.vue?vue&type=script&lang=js&"
import style0 from "./yuan.vue?vue&type=style&index=0&id=080556aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080556aa",
  null
  
)

export default component.exports